import AddInvoiceEntry from '../AddInvoiceEntry'

export default function AddRedInvoiceEntry() {
  return <AddInvoiceEntry pageType="RED" />
}
import AddInvoiceEntry from '../AddInvoiceEntry'

export default function AddRedInvoiceEntry() {
  return <AddInvoiceEntry pageType="RED" />
}
